module.exports = __webpack_public_path__ + "img/bg@2x.d4a0ce6a.png";